import { isTauri } from "@/lib/is-tauri";

/**
 * Opens an external URL in the user's default browser (desktop) or a new
 * tab (web). The browser decides the window; Denker never sizes or places it.
 */
export async function openExternalUrl(
  url: string,
  options: {
    /** Web only: "tab" (default) = new tab; "self" = same-tab navigation (standard redirect flows). */
    webTarget?: "tab" | "self";
  } = {},
): Promise<void> {
  if (isTauri()) {
    const { openUrl } = await import("@tauri-apps/plugin-opener");
    await openUrl(url);
    return;
  }
  if (options.webTarget === "self") {
    window.location.href = url;
    return;
  }
  window.open(url, "_blank", "noopener,noreferrer");
}
